import localforage from 'localforage';

const appEnv = import.meta.env.VITE_APP_ME_ENV;

const exactKeys = new Set<string>([
  `persist:me_${appEnv}`,
  `mitt-malarenergi-${appEnv}`,
  'bekrafta_konto',
]);

const oidcPrefixes = ['oidc.', 'oidc:'];

const isAppLocalforageKey = (key: string) => {
  if (exactKeys.has(key)) {
    return true;
  }

  if (key.startsWith('headsup-')) {
    return true;
  }

  if (key.endsWith('showInvoiceFilter')) {
    return true;
  }

  return oidcPrefixes.some((prefix) => key.startsWith(prefix));
};

export const clearAppLocalforageData = async () => {
  const keys = await localforage.keys();
  const keysToRemove = keys.filter(isAppLocalforageKey);

  await Promise.all(keysToRemove.map((key) => localforage.removeItem(key)));
};
